import { CUSTOMER_JOURNEY_HOTEL_SUCCESS } from './../const';
import { trackPage } from './../../stores/reactGaMiddleware';

function _action(data) {
  return { type: CUSTOMER_JOURNEY_HOTEL_SUCCESS, data };
}

function action(data) {
  // return { type: CUSTOMER_JOURNEY_HOTEL_SUCCESS, data };

  return (dispatch, getState) => {

    if(!getState().hotel.apiData.id) {
      const page = getState().router.location.pathname.split( '/' )[1];
      const propid = data.id;
      const taid = data.ta_id;
      const name = data.name;
      const brand = data.template;

      console.log('GA - Traking first page...');
      trackPage(page, propid, taid, name, brand);
    }
    
    return dispatch(_action(data));
  };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyHotelSuccess.js